import { gql } from "@apollo/client";

export const productCategoryListQuery = gql`
  query productCategoryList {
    productCategoryList {
      id
      name
    }
  }
`;

export const deleteProductCategoryMutation = gql`
  mutation deleteProductCategory($input: DeleteProductCategoryInput!) {
    deleteProductCategory(input: $input) {
      id
      name
    }
  }
`;

export const productCategoryQuery = gql`
  query productCategory($id: ID!) {
    productCategory(id: $id) {
      id
      name
    }
  }
`;

export const createProductCategoryMutation = gql`
  mutation createProductCategory($input: CreateProductCategoryInput!) {
    createProductCategory(input: $input) {
      id
      name
    }
  }
`;

export const updateProductCategoryMutation = gql`
  mutation updateProductCategory($input: UpdateProductCategoryInput!) {
    updateProductCategory(input: $input) {
      id
      name
    }
  }
`;
